import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import { Button } from '../fields';
import Icon from '../Icon';
import Logo from '../logos';
import Box from '../Box';

import styles from './TopBar.less';

const cx = classnames.bind(styles);

TopBar.propTypes = {
  app: PropTypes.oneOf(['datadesk']),
};

export default function TopBar({ app, children, ...props }) {
  return (
    <div className={cx('bar')}>
      <Box className={cx('content')}>
        <div>
          <Button className={cx('menu')} icon={<Icon name="icon-multi-menu" />} />

          <Logo app={app} />
        </div>
        {children}
      </Box>
    </div>
  );
}
